/**
 * Re-exports the full Lovable `articles` dataset (see `thi-articles.data.ts`).
 */
import { articles } from './thi-articles.data';
export { articles, categoryTranslations, type Article } from './thi-articles.data';
export const THI_LANDING_ARTICLES = articles;
export type ThiArticleListItem = import('./thi-articles.data').Article;
export type ArticleCategory = 'business' | 'finance' | 'productivity' | 'technology';
